import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  stepperWrapper: {
    padding: '30px 0',
    position: 'sticky',
    top: '60px',
    zIndex: '200',
    backgroundColor: palette.shades[200],
    borderBottom: "1px solid ".concat(palette.shades[300]),
    boxShadow: palette.shadows.light
  },
  hideBreadcrumbs: {
    top: '0'
  },
  activeStep: {
    '& .MuiStepLabel-iconContainer path': {
      fill: palette.primary.dark
    }
  },
  disabledStep: {
    pointerEvents: 'none'
  },
  stepLink: {
    display: 'inline-block',
    textDecoration: 'none'
  }
});
export default useStyles;